<script lang="ts">
  import { router } from "@inertiajs/svelte"

  import TaskList from "@/components/task/task-list.svelte"
  import AppLayout from "@/layouts/app-layout.svelte"
  import { approveTaskInstancePath, pendingApprovalTaskInstancesPath } from "@/routes"
  import type { BreadcrumbItem, TaskInstance } from "@/types"

  interface Props {
    pendingTasks: TaskInstance[]
  }

  let { pendingTasks }: Props = $props()

  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Pending Approval",
      href: pendingApprovalTaskInstancesPath(),
    },
  ]

  function handleApprove(taskInstance: TaskInstance) {
    router.post(approveTaskInstancePath(taskInstance.id), {}, {
      preserveScroll: true,
    })
  }
</script>

<svelte:head>
  <title>Pending Approval - Chorizo</title>
</svelte:head>

<AppLayout {breadcrumbs}>
  <div class="flex h-full flex-1 flex-col gap-6 overflow-x-auto rounded-xl p-4">
    <div>
      <h1 class="text-3xl font-bold">Pending Approval</h1>
      <p class="text-muted-foreground mt-2">Review and approve completed tasks</p>
    </div>

    <TaskList
      tasks={pendingTasks}
      title="Tasks Pending Approval"
      showActions={true}
      onApprove={handleApprove}
    />
  </div>
</AppLayout>
